import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';

const ModalInforme = (props) => {
    const { datosModal, setAutorizar, setBotonModal, ...rest } = props;
    const { esIndicador, esAutorizado } = datosModal;
    const [mensajeModal, setMensajeModal] = useState({ titulo: "", texto: "" });

    const botonAceptar = () => {
        if (esAutorizado === "Autorizado")
        {
            setAutorizar(true)
        }
        else
        {
            setAutorizar(false)
        }
        setBotonModal(true);
        rest.onHide();
    }

    useEffect(() => {
        if (esIndicador === false) {
            if (esAutorizado === "Autorizado") 
            {
                setMensajeModal({ titulo: "¿Está seguro que desea aprobar este Informe de conservación?" });
            } 
            else 
            {
                setMensajeModal({ titulo: "¿Está seguro que desea rechazar esta informe de conservación?" });
            }
        }
    }, [props]);

    return (
        <Modal
            {...rest}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Body>
                <div className='info my-4'>
                    <span className='info__icon'>
                        <i className='ico-user-delete'></i>
                    </span>
                    <h6 className='info__title'>{mensajeModal.titulo}</h6>
                    <p className='info__text'>{mensajeModal.texto}</p>
                </div>
                <div className="d-flex flex-column flex-md-row justify-content-center align-items-stretch align-items-md-center gap-4">
                    <Button type="button" design="btn-outline-pewter-blue btn--small" onClick={rest.onHide}>Cancelar</Button>
                    <Button type="button" design="btn-primary btn--small" onClick={botonAceptar}>Aceptar</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalInforme;